/**
 * Contract for the LLM-backed topic insights panel: the browser sends a small,
 * pre-aggregated picture of a topic view (top rows + totals — never raw
 * records) and the BFF returns a handful of toned insight bullets.
 */

export const TOPIC_INSIGHTS_ROUTE = '/_assist/topic-insights';

export type TopicInsightTone = 'headline' | 'opportunity' | 'watch';

export interface TopicInsight {
    tone: TopicInsightTone;
    text: string;
}

export interface TopicInsightsRow {
    label: string;
    value: number;
    /** This row's share of the metric total, 0–1. */
    share: number;
}

export interface TopicInsightsRequest {
    surfaceTitle: string;
    topicTitle: string;
    question: string;
    /** Singular noun for a row (e.g. "task category"). */
    lensLabel: string;
    /** Human label of the headline metric (e.g. "Turns"). */
    metricLabel: string;
    totals: Record<string, number>;
    rows: TopicInsightsRow[];
}

export interface TopicInsightsReply {
    insights: TopicInsight[];
}
